module.exports = __webpack_public_path__ + "img/T2B_xh_1.57eb9540.png";